/**
 * PÁGINA DE CONTACTO
 * ===================
 * Esta página permitirá a los usuarios contactar con Plaza Rural:
 * - Formulario de contacto
 * - Información de ubicación y oficinas
 * - Teléfonos y emails de contacto
 * - Mapa interactivo
 * - Horarios de atención
 * 
 * ESTADO ACTUAL: Página en construcción
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, ArrowLeft } from 'lucide-react';

const ContactoPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 pt-24">

      <div className="max-w-7xl mx-auto px-4 py-12">

        <div className="bg-white rounded-2xl shadow-xl p-12 text-center">

          {/* Icono de contacto */}
          <div className="flex justify-center mb-6">
            <div className="bg-green-100 rounded-full p-6">
              <Mail className="w-16 h-16 text-green-600" />
            </div>
          </div>

          {/* Título */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Contacto
          </h1>

          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            ¿Tenés alguna consulta? Estamos aquí para ayudarte.
          </p>

          {/* Medios de contacto */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">

            <div className="bg-gray-50 rounded-xl p-6">
              <Phone className="w-12 h-12 text-green-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Teléfono</h3>
              <p className="text-gray-600 text-sm">
                0800 8122
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <Mail className="w-12 h-12 text-green-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Email</h3>
              <p className="text-gray-600 text-sm">
                info@plazarural.com
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <MapPin className="w-12 h-12 text-green-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Ubicación</h3>
              <p className="text-gray-600 text-sm">
                Uruguay
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <Clock className="w-12 h-12 text-green-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Horarios</h3>
              <p className="text-gray-600 text-sm">
                Lun a Vie 9:00 - 18:00
              </p>
            </div>
          </div>

          {/* Estado */}
          <div className="mt-12 bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-green-800 font-medium">
              🚧 Formulario de contacto en construcción. Por ahora, comunicate por teléfono o email.
            </p>
          </div>

          {/* Botón Volver */}
          <div className="mt-8">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
            >
              <ArrowLeft className="w-5 h-5" />
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactoPage;